import { createContext, type PropsWithChildren, useContext } from 'react'
import { useParams } from 'react-router'
import { withProductId } from '@/components/stella/mentionProduct'
import type { MentionItem } from '@/components/stella/types'
import { type StellaSession, useStellaSession } from '@/hooks/useStellaSession'

const StellaProviderContext = createContext<StellaSession | null>(null)

export const StellaProvider = ({ children }: PropsWithChildren) => {
  const session = useStellaSession({})

  return (
    <StellaProviderContext.Provider value={session}>
      {children}
    </StellaProviderContext.Provider>
  )
}

export const useStella = (): StellaSession => {
  const context = useContext(StellaProviderContext)
  const { productId } = useParams()

  if (context === null) {
    throw new Error('useStella must be used within a StellaProvider')
  }

  const setInitialMentions = (
    mentions: MentionItem[],
    hiddenMentions?: MentionItem[]
  ) =>
    context.setInitialMentions(
      mentions.map((mention) => withProductId(mention, productId)),
      hiddenMentions
    )

  return { ...context, setInitialMentions }
}
